export const UK_PHONE_NUMBER = '0800 028 5867';
export const UK_PHONE_NUMBER_INTERNATIONAL = '+44 (0)800 028 5867';
export const IE_PHONE_NUMBER = '+353 1 533 1720';
export const COUNTRY_CODE_UK = 'UK';
export const COUNTRY_CODE_IE = 'IE';
